/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutTrackingPresetCounts } from './CarveOutTrackingPresetCounts';
import {
    CarveOutTrackingPresetCountsFromJSON,
    CarveOutTrackingPresetCountsFromJSONTyped,
    CarveOutTrackingPresetCountsToJSON,
    CarveOutTrackingPresetCountsToJSONTyped,
} from './CarveOutTrackingPresetCounts';

/**
 * 
 * @export
 * @interface FindCarveOutTrackingPresetCounts200Response
 */
export interface FindCarveOutTrackingPresetCounts200Response {
    /**
     * 
     */
    data?: CarveOutTrackingPresetCounts;
}

/**
 * Check if a given object implements the FindCarveOutTrackingPresetCounts200Response interface.
 */
export function instanceOfFindCarveOutTrackingPresetCounts200Response(value: object): value is FindCarveOutTrackingPresetCounts200Response {
    return true;
}

export function FindCarveOutTrackingPresetCounts200ResponseFromJSON(json: any): FindCarveOutTrackingPresetCounts200Response {
    return FindCarveOutTrackingPresetCounts200ResponseFromJSONTyped(json, false);
}

export function FindCarveOutTrackingPresetCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCarveOutTrackingPresetCounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CarveOutTrackingPresetCountsFromJSON(json['data']),
    };
}

export function FindCarveOutTrackingPresetCounts200ResponseToJSON(json: any): FindCarveOutTrackingPresetCounts200Response {
    return FindCarveOutTrackingPresetCounts200ResponseToJSONTyped(json, false);
}

export function FindCarveOutTrackingPresetCounts200ResponseToJSONTyped(value?: FindCarveOutTrackingPresetCounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CarveOutTrackingPresetCountsToJSON(value['data']),
    };
}

